/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title[_ngcontent-%COMP%]{max-width:400px}.form[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap}"];
export { styles as styles };
